export const routes = {
    DASHBOARD: '/',
    INTRO: '/intro',
    TASK_SELECTION: '/tasks',
    POST_SURVEY: '/postsurvey',

    TASK: "/task/:task",
    SUBTASK: "/task/:task/:branchid",

    TASK_FINISH: "/task/:task/story",

    COMPLETION: "/complete/:task",
    NOT_FOUND: "/404",
    FIN: "/fin",

    COORDFINDER: "/hidden/coordfinder"
};